import CopyTextIcon from '@/shared/assets/icons/copyText.svg?react'
import { useCopyToClipboard } from '@/shared/hooks'
import { Toast } from '@/shared/ui'
import {
    UTMLinkEditDialog,
    type UTMLinkEditDialogProps,
} from '../../../../InviteLinksTable/UTMLinkEditDialog'

import { IconButton } from '@/true-fsd/shared/ui/ButtonLink'

import { coerceUrl } from '@synapex/tools/utils'
import classes from './LinkView.module.scss'

const shortHref = (url: URL) => {
    const { hostname, pathname, search, protocol } = url

    const spOmitErid = new URLSearchParams(search)
    const erid = spOmitErid.get('erid')
    spOmitErid.delete('erid')

    if (spOmitErid.size > 0) {
        //potentially long
        let result = `${protocol}//${hostname}`

        if (pathname === '' || pathname === '/') {
            result += `/`
        } else {
            result += pathname
        }

        result += '...'

        if (erid) {
            result += `&erid=${erid}`
        }

        return result
    } else {
        return url.href
        // return hrefOmitProtocol(url)
    }
}

export type LinkViewProps = UTMLinkEditDialogProps & {}
export const LinkView = ({
    siteLink,
    utmLink,
    erid,
    ...dialogProps
}: LinkViewProps) => {
    const { copy, hideToast, toastMessage, toastVisible } = useCopyToClipboard()

    const url = (() => {
        if (siteLink.siteLinkUrl) {
            const { hostname, pathname } = siteLink.siteLinkUrl
            return coerceUrl(`${hostname}/${pathname}`)
        } else {
            return coerceUrl(utmLink.baseUrl)
        }
    })()

    if (!url) {
        return
    }

    if (erid) {
        url.searchParams.append('erid', erid)
    }

    return (
        <>
            <div className={classes.root}>
                <div className={classes.linkText}>{shortHref(url)}</div>
                <IconButton
                    Icon={CopyTextIcon}
                    onClick={() => copy(decodeURIComponent(url.href))}
                />
                <UTMLinkEditDialog
                    {...dialogProps}
                    utmLink={utmLink}
                    siteLink={siteLink}
                    erid={erid}
                />
            </div>
            <Toast
                message={toastMessage}
                visible={toastVisible}
                onClose={hideToast}
                greenSwooshIcon={false}
            />
        </>
    )
}
